// extracted by mini-css-extract-plugin
module.exports = {"section":"Title-module--section----jK7","container":"Title-module--container--3ZVUN"};